import { type FC, type SVGProps } from 'react';

const OngoingProjectIcon: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    fill="none"
    viewBox="0 0 16 16"
  >
    <path
      fill="#DE2D44"
      d="M11.667 1.667 15.333 8l-3.666 6.334H4.333L.667 8l3.666-6.333zM10.897 3H5.103L2.207 8l2.895 5h5.796l2.895-5zm-3.564 7h1.334v1.334H7.333zm0-5.333h1.334v4H7.333z"
    ></path>
  </svg>
);
export default OngoingProjectIcon;
